import React from 'react';

import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as NavLink } from 'react-router';

import {
  CompleteButtonStyled,
  CompletedWrapperStyled,
  CompleteInfoStyled,
  CompleteTitleStyled,
} from '../../styles';

const SignUpCompleted = React.memo(() => {
  const { t } = useTranslation();

  return (
    <CompletedWrapperStyled>
      <CompleteTitleStyled variant="h1">{t('signup.completed.title')}</CompleteTitleStyled>

      <Stack>
        <CompleteInfoStyled>{t('signup.completed.info_1')}</CompleteInfoStyled>
        <CompleteInfoStyled>{t('signup.completed.info_2')}</CompleteInfoStyled>
      </Stack>

      <Box>
        <CompleteButtonStyled component={NavLink} to="/auth/signin" variant="contained">
          {t('signup.completed.button')}
        </CompleteButtonStyled>
      </Box>
    </CompletedWrapperStyled>
  );
});

export default SignUpCompleted;
